const e = 240, r = (t) => ({
  id: void 0,
  caption: t("public_pages_purchase.form_select.empty_list"),
  className: "bg-background-secondary hover:bg-background-secondary cursor-default text-text-tertiary/70 hover:text-text-tertiary/70",
  disabled: !0
});
export {
  e as MAX_PANEL_HEIGHT,
  r as getEmptyValue
};
